import { TableCell } from '@material-ui/core';
import { useUserContext } from 'common/contexts/UserContext';
import StatusIcon from 'components/StatusIcon';
import _ from 'lodash';
import * as React from 'react';
import { Shift } from 'services/helpers/shift';
import { ErlContext } from 'pages/T_Appointments/context';
import WithLegendPopover from '../../../WithLegendPopover';
import { clockStatus, MESSAGES, SHIFTS_REF } from '../../constants/next-appointments.constants';
import { NextAppointmentsService } from '../../services/next-appointments.service';
import { GateClosedCell } from './GateClosed';

interface Props {
  shift: Shift;
  terminalKey: string;
  terminalUrl: string;
  instructions: { status: string; warnings: string[] };
  classes: Record<string, string>;
  isPTSC: boolean;
  currentSLKey: string;
  currentContainerKey: string;
}

export const ITSCell: React.FC<Props> = (props) => {
  const {
    shift,
    terminalKey,
    terminalUrl,
    instructions,
    classes,
    isPTSC,
    currentContainerKey,
    currentSLKey,
  } = props;

  const { user } = useUserContext();
  const erlData = React.useContext(ErlContext);

  const { status, warnings } = instructions || {};
  let message = MESSAGES.noAppointmentRequired;
  if (shift && terminalKey) {
    const gateData = NextAppointmentsService.getGateData(erlData.gateHours, terminalKey, shift);
    if (NextAppointmentsService.checkIsGateClosed(gateData)) {
      message = MESSAGES.gateClosed;
    }
  }

  if (message && message === MESSAGES.gateClosed) {
    return <GateClosedCell message={message} shift={shift} classes={classes} />;
  }

  let className;
  let isGrey = false;
  if (status && (status === 'yes' || status === 'dual')) {
    className = shift.shift === SHIFTS_REF.shift2 ? classes.cellAppointmentsFat : classes.cell;
  } else {
    isGrey = true;
    className =
      shift.shift === SHIFTS_REF.shift2
        ? classes.cellAppointmentsGreyFat
        : classes.cellAppointmentsGrey;
  }

  return (
    <TableCell
      className={className}
      align="center"
      onClick={() => {
        NextAppointmentsService.fireGAcellClickEvent(
          currentSLKey,
          currentContainerKey,
          user,
          terminalKey,
          shift
        );
        window.open(terminalUrl);
      }}
    >
      <WithLegendPopover
        isShown
        status={status || clockStatus}
        warnings={warnings}
        formattedTimeSlot={_.capitalize(message)}
        isPTSC={isPTSC}
      >
        {status !== 'no' && <div>{message}</div>}
        {currentContainerKey && (
          <StatusIcon
            status={status || clockStatus}
            warnings={warnings}
            isGrey={isGrey}
            isEmptyAppointments
          />
        )}
      </WithLegendPopover>
    </TableCell>
  );
};
